import { Outlet } from 'react-router-dom'
export default function Layout () {
  return (
    <div className='md:container container-sm mx-auto px-4 lg:px-12'>        
      <Outlet />
    </div>
  )
}